export class Device {
    constructor(public id?: string, public name?: string) { }
}

export class UserModel {
    constructor(public firstName?: string,
                public lastName?: string,
                public devices?: string[],
                public devicesGroups?: string[],
                public presentations?: string[],
                public owners = {}
    ) { }
}



// WEBPACK FOOTER //
// ./src/app/views/user/models/user.model.ts